var _g, _g2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInviteTeammember(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.19,
    height: 13.19
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16202"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16201"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10375",
    d: "M9.469 6.618a6.7 6.7 0 00-.775-.311 3.5 3.5 0 10-4.2 0A6.7 6.7 0 00.034 11.3a1.565 1.565 0 001.53 1.888h6.345a.515.515 0 100-1.03H1.564a.524.524 0 01-.412-.2.538.538 0 01-.109-.451A5.692 5.692 0 016.459 7h.275a5.612 5.612 0 012.294.545.515.515 0 00.442-.931zm-2.748-.645h-.25a2.473 2.473 0 11.25 0z",
    fill: "#001847"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16204"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 16203"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 10376",
    d: "M12.674 10.227h-1.417V8.81a.515.515 0 10-1.03 0v1.417H8.81a.515.515 0 000 1.03h1.417v1.417a.515.515 0 101.03 0v-1.417h1.417a.515.515 0 000-1.03z",
    fill: "#001847"
  })))));
}

export default SvgInviteTeammember;